import React from 'react';
import { useSite } from '../../context/SiteContext';
import { CheckCircle2, Info, AlertTriangle, XCircle } from 'lucide-react';

export const ToastContainer: React.FC = () => {
  const { toasts } = useSite();

  if (!toasts || toasts.length === 0) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-2 pointer-events-none max-w-sm w-full">
      {toasts.map((toast) => {
        let icon = <CheckCircle2 className="w-4 h-4 text-emerald-400 shrink-0" />;
        let borderClass = 'border-emerald-500/30 bg-[#162238]/95 text-slate-100 shadow-xl';

        if (toast.type === 'error') {
          icon = <XCircle className="w-4 h-4 text-rose-400 shrink-0" />;
          borderClass = 'border-rose-500/30 bg-[#162238]/95 text-slate-100 shadow-xl';
        } else if (toast.type === 'warning') {
          icon = <AlertTriangle className="w-4 h-4 text-amber-400 shrink-0" />;
          borderClass = 'border-amber-500/30 bg-[#162238]/95 text-slate-100 shadow-xl';
        } else if (toast.type === 'info') {
          icon = <Info className="w-4 h-4 text-blue-400 shrink-0" />;
          borderClass = 'border-blue-500/30 bg-[#162238]/95 text-slate-100 shadow-xl';
        }

        return (
          <div
            key={toast.id}
            className={`pointer-events-auto flex items-center gap-3 px-4 py-3 rounded-xl border backdrop-blur-md transition-all duration-300 animate-in fade-in slide-in-from-bottom-2 ${borderClass}`}
          >
            {icon}
            <span className="text-xs font-semibold text-slate-200 leading-snug">{toast.message}</span>
          </div>
        );
      })}
    </div>
  );
};
